import { createSlice } from '@reduxjs/toolkit'

import { Avatar_5 } from '../../assets/img'

let newState

const avatarDefault = [{
  avatar_asset_ids: [{key:1,  value: -1}],
  data: [{ "key":1, "value": Avatar_5 },
   { "key":2, "value": Avatar_5 },
   { "key":3, "value": Avatar_5 },
   { "key":4, "value": Avatar_5 },
    { "key":5, "value": Avatar_5 }],
}]

const profileSlice = createSlice({
  name: 'profileCollection',
  initialState: {
    isLoading: false,
    nickname: '',
    currentAvatar: avatarDefault,
    status: 'NOT_FETCHED',
  },
  reducers: {
    getProfile() {
      console.log('getProfile')
    },
    setProfile(state, action) {
      switch (action.payload.type) {
        case 'GET_PROFILE':
          newState = {
            ...state,
            isLoading: true,
            status: 'GET_AVATAR',
            error: '',
          }
          return newState
        case 'FETCHING_SUCCESS':
          newState = {
            ...state,
            isLoading: false,
            status: 'FETCHING_SUCCESS',
            avatars: action.payload.avatars,
            currentAvatar:
              action.payload.currentAvatar.asset_id === 0
                ? avatarDefault
                : action.payload.currentAvatar,
            error: '',
          }
          return newState
        case 'FETCHING_ERROR':
          newState = {
            ...state,
            isLoading: false,
            status: 'FETCHING_ERROR',
            error: action.payload.error,
          }
          return newState
        case 'FETCHING_CANCELLED':
          newState = {
            ...state,
            isLoading: false,
            status: 'FETCHING_CANCELLED',
          }
          return newState
        default:
          break
      }
    },
  },
})

export const { getProfile, setProfile } = profileSlice.actions

export default profileSlice.reducer
